import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import { connect } from "react-redux";
import moment from "moment";
import { Grid, Button } from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
const useStyles = makeStyles((theme) => ({
  paper: {
    border: "1px solid",
    borderRadius: 10,
    padding: theme.spacing(1),
    backgroundColor: "white",
    marginTop: "30px",
    marginRight: "20px",
    color: "#424242",
    zIndex: 9999,
  },
}));
interface Props {
  setAnchorElUpdate: any;
  anchorElUpdate: any;
  id: any;
}

const SystemUpdateDetails: React.FC<Props> = ({
  setAnchorElUpdate,
  anchorElUpdate,
  id,
}) => {
  const classes = useStyles();
  const open = Boolean(anchorElUpdate);

  return (
    <div>
      <Popper id={id} open={open} anchorEl={anchorElUpdate} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className={classes.paper}>
              gnadmin Message:
              <hr />
              <li>
                All CC update their KYC
                <sub>({moment().format("DD-MM-YYYY")})</sub>
              </li>
              <hr />
              <div>
                <Grid container>
                  <Grid item xs={9}>
                    <TextareaAutosize
                      aria-label="Type Message"
                      minRows={2}
                      placeholder="Type Message"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      variant="contained"
                      fullWidth
                      size="small"
                      color="primary"
                    >
                      Send
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, {})(SystemUpdateDetails);
